
define('tpl!taoQtiItem/qtiCreator/tpl/forms/response/graphicScoreMappingForm', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function";

function program1(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <div class=\"panel\" data-edit=\"correct\">\n            <label>\n                "
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Correct", options) : helperMissing.call(depth0, "__", "Correct", options)))
    + "\n                <input name=\"correct\" type=\"checkbox\" ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.correct), {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " />\n                <span class=\"icon-checkbox\"></span>\n            </label>\n            <span class=\"icon-help tooltipstered\" data-tooltip=\"~ .tooltip-content:first\" data-tooltip-theme=\"info\"></span>\n            <span class=\"tooltip-content\">"
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Is this choice the correct response?", options) : helperMissing.call(depth0, "__", "Is this choice the correct response?", options)))
    + "</span>\n        </div>\n";
  return buffer;
  }
function program2(depth0,data) {
  
  
  return " checked=\"checked\"";
  }

  buffer += "    <a class=\"closer\" href=\"#\" data-close=\":parent .mapping-editor\"></a>\n    <div class=\"form-container\">\n        <h2>";
  if (helper = helpers.identifier) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.identifier); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</h2>\n\n";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.noCorrect), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        <div class=\"panel\">\n            <label for=\"score\">"
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Score", options) : helperMissing.call(depth0, "__", "Score", options)))
    + "</label>\n            <input value=\"";
  if (helper = helpers.score) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.score); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" type=\"text\" data-for=\"";
  if (helper = helpers.identifier) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.identifier); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" name=\"score\" class=\"score\" data-validate=\"$numeric\" data-validate-option=\"$allowEmpty; $event(type=keyup)\" />\n            <span class=\"icon-help tooltipstered\" data-tooltip=\"~ .tooltip-content:first\" data-tooltip-theme=\"info\"></span>\n            <span class=\"tooltip-content\">"
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Set the score for this response", options) : helperMissing.call(depth0, "__", "Set the score for this response", options)))
    + "</span>\n        </div>\n        <span class=\"arrow\"></span>\n        <span class=\"arrow-cover\"></span>\n    </div>\n";
  return buffer;
  });
});

